import React, { useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
//import "./Login.css";
import { useState } from "react";
import img from "../../assets/sign-in-back.svg";
import { handleError, handleSuccess } from "../../Utils";
import { getProfileRole, sendEmailOtp } from "../../ApiServices/ApiServices";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Codequeue - Forget Password";
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      return handleError("Please provide an email");
    }
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email)) {
      return handleError("Please Enter Valid Email.");
    }

    try {
      const res = await getProfileRole(email);
      const role = res.role;
      const response = await sendEmailOtp(email);
      handleSuccess(response.message);
      setTimeout(() => {
        navigate("/new-password", { state: { email, role } });
      }, 800);
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }
  };

  return (
    <div className="flex justify-center items-start pt-16 px-4 flex-wrap login">
      <div className="left w-[30rem] gap-8 py-4 px-10">
        <div className="left-mid gap-10">
          <h1 className="text-4xl">Forgot your password?</h1>
          <p>
            To reset your password, please enter the email address of your
            CodeQueue account.
          </p>
        </div>

        <div>
          <form onSubmit={handleSubmit} className="login-form flex flex-col">
            <div className="form-group flex flex-col mt-3">
              <label htmlFor="email" className="text-[16px] font-bold">
                Email :{" "}
              </label>
              <input
                type="text"
                value={email}
                placeholder="Email"
                onChange={(e) => setEmail(e.target.value.trim().toLowerCase())}
                className="h-10 rounded-md border border-gray-300 px-2 font-semibold"
              />
            </div>

            <button
              type="submit"
              className="primary-btn submit-btn my-6 py-2 px-4 bg-blue-500 text-white rounded-md hover:bg-blue-600"
            >
              Reset Password
            </button>
          </form>
        </div>

        <div className="divider flex items-center">
          <hr className="divider-line flex-1 h-px bg-gray-300 border-none" />
        </div>

        <div className="w-full text-center">
          <NavLink
            to={"/contact"}
            className="text-gray-700 hover:underline"
          >
            Contact Us
          </NavLink>
        </div>
      </div>

      <div className="right w-[30rem] pt-10 bg-cover bg-center overflow-hidden">
        <img src={img} alt="Img" className="w-full" />
      </div>
    </div>
  );
};

export default ForgotPassword;
